<template lang="pug">
    .contact-container
        .contact-content
            .title {{ $t('留下联系方式，获取更多信息') }}
            el-button(
                @click="onClick"
            ) {{ $t('咨询合作')}}
</template>
<script>
export default {
  methods: {
    onClick () {
      this.$router.push('/contact?redirectUrl=' + this.$route.path + '&buttonName=咨询合作')
    }
  }
}
</script>

<style lang="stylus">
.contact-container
    height 380px
    background-size 100% 100%
    background-image url(../assets/contact-bg.png)
    display flex
    align-items center
    justify-content center
    .contact-content
        display flex
        flex-direction column
        align-items center
        justify-content center
        .title
            display block
            font-size 42px
            font-weight 600
            color #ffffff
            margin-bottom 34px
        .el-button
            width 163px
            height 48px
            border-radius 25px
            background-color #ffffff
            border-color #ffffff
            color #478bca
            font-size 20px
            font-weight 600
</style>
